const Header = require("../dom/header");
const ScrSec = require('../animation/section_scroll');
const Pagetop= require('../dom/pagetop');

const Utill  = require("../utillity/utill");
const Rwd    = require("../utillity/responsive");


module.exports.Bind = function() {
	$(document).on('click', '[data-hamburger]', function() {
		Header.ToggleHamburger();
	});

	$(document).on('click', '[data-page_controller]', function() {

		Pagetop.Move();
	});

	$(document).on('click', '[data-pagination] button', function(el) {
		if( Utill.IsOriginAnime() ) {
			let curr = Number( $('[data-current="true"]').attr('data-num') );
			let next = $(this).closest('li').index();
			var direction;
			if( curr > next ) {
				direction = -1;
			}else if( curr < next ) {
				direction = 1;
			}else {		// 恐らく同じボタンを押しているはず。おそらく。。
				return;
			}

			ScrSec.ChangeSec( direction, next );
		}else {
			ScrSec.Pager( $(this) );
		}
	});

	$(document).on('click', '.gHeader-logo__anchor', function() {
		if( Utill.IsOriginAnime() ) return;
		Pagetop.Move();
		location.href = '/';
	});

	$(document).on('click', '.press-arc__btn', function() {
		$('.press-arc__list-item').fadeIn(600);
		$(this).remove();
		return false;
	});
};


// WEBPACK FOOTER //
// ./html/_src/js_wb/events/click.js